import Storage from "../../utils/storage";

export function removeStorageItems() {
  Storage.remove("user-access-data");
  Storage.remove("user-access-token");
  Storage.remove("decoded-data");
  Storage.remove("user-email");
  Storage.remove("staffPassword");
  Storage.remove("keep");
  Storage.remove("current-user");
  Storage.remove("user-access-refresh-token");
  Storage.remove("kit-download");
  Storage.remove("select-type");
  Storage.remove("selection");
  Storage.remove("kit-download-single");
  Storage.remove("select-type-single");
  Storage.remove("selection-single");
  Storage.remove("upload-start-single");
  Storage.remove("upload-start");
  Storage.remove("migrationStart");
  Storage.remove("docApproved");
  Storage.remove("account-number");
  Storage.remove("wsdl-url");
  Storage.remove("startIpSubmission");
  Storage.remove("data");
  Storage.remove("start-value");
  Storage.remove("end-value");
  Storage.remove("merchant_class");
}
